module.exports = __webpack_public_path__ + "token_wallet.e51b1e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/token_wallet.png
// module id = 560
// module chunks = 0